import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.#activate(0)
  }

  select(event) {
    this.#activate(this.tabTargets.indexOf(event.currentTarget))
  }

  #activate(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.dataset.active = i === index
    })
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index
    })
  }
}
